<h3 class="title">Sender Details</h3>
<terra-unit-payment-overview-key-value-pair key="Name" [value]="senderName" iconName="person">
</terra-unit-payment-overview-key-value-pair>
<terra-unit-payment-overview-key-value-pair key="Account" [value]="sourceBankAccount?.accountNickname" iconName="attach_money" [link]="linkToBankAccountPage">
</terra-unit-payment-overview-key-value-pair>
<terra-unit-payment-overview-key-value-pair key="Holding" [value]="sourceBankAccount?.unitApplication?.holding?.name" iconName="location_city" [link]="linkToHolding">
</terra-unit-payment-overview-key-value-pair>
